/**
 * Single source of truth for plan display prices on the frontend.
 *
 * Stripe always bills in GBP (see `backend/core.py`). The USD values here are
 * for display only — they are the rounded prices we want to show US visitors
 * (e.g. $11.99 instead of an FX-converted $12.69). The marketing pages call
 * `formatPrice(PLAN_PRICES.basic)` from `RegionContext` which picks the right
 * one based on the active region.
 */
export const PLAN_PRICES = {
  trial: { gbp: 0, usd: 0 },
  basic: { gbp: 9.99, usd: 11.99 },
  pro: { gbp: 15.99, usd: 19.99 },
};
